import React, { useEffect } from 'react'
import {
  Button,
  TextField,
  CircularProgress
} from '@material-ui/core'
import {
  actions
} from '../../listView.reducer'
import { ListViewDispatchContext, ListViewStateContext } from '../../listView.context'
import { refillTemplate, getInitialState } from './email'
import { getEmailTemplates, validators } from './helper'
import { massProcessingApi, surveyApi } from '@atheneum/api'
import Autocomplete from '@material-ui/lab/Autocomplete'

export const rapidSurvey = {
  name: 'rapidSurvey',
  title: 'Run Rapid Survey',
  // REVIEW: REMOVED FOR DEMO - ADD BACK
  loadStage: 1,
  // loadStage: 3,
  component: RapidSurveyForm,
  stages: [
    {
      validators: [validators.email],
      full: false,
      component: SurveySelector
    },
    // REVIEW: REMOVED FOR DEMO - ADD BACK
    // emailStages[0],
    // emailStages[1],
    {
      validators: [validators.email],
      component: StatusPage,
      full: false
    }
  ],
  finishAction: sendSurveys
}


function RapidSurveyForm({ massAction, items }) {
  const initialEmailState = getInitialState();
  const [state, setState] = React.useState({
    ...initialEmailState,
    loadingSurveys: true,
    template: null,
    additionalReplacements: [{ key: 'surveyLink', value: 'surveyLink' }],
    additionalItemData: (item, state) => ({
      surveyLink: '{{surveyLink}}'
    }),
    // override email finish action
    finishAction: sendSurveys,
    surveys: []
  })

  useEffect(() => {
    surveyApi.listSurveys({ states: ['WaitingForLaunch', 'AcceptingResponses'] }).then(
      surveys => {
        setState(s => ({ ...s, loadingSurveys: false, surveys }))
      }
    )
  }, [massAction.stage])

  const initialLoad = async () => {
    const { initialEmailTemplate } = await getEmailTemplates('al_survey')

    setState({
      ...state,
      template: initialEmailTemplate
    })
  }

  useEffect(() => {
    initialLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const stage = rapidSurvey.stages[massAction.stage]
  const StageComponent = stage && stage.component

  return StageComponent ? (
    <StageComponent
      items={items}
      state={state}
      setState={setState}
      action={rapidSurvey}
    />
  ) : null
}


function SurveySelector({ state, setState }) {
  const dispatch = React.useContext(ListViewDispatchContext)
  const listViewState = React.useContext(ListViewStateContext)

  return !state.surveys.length ? (
    <CircularProgress
      style={{
        color: '#429bdc',
        width: '25px',
        height: '25px'
      }}
    />
  ) : (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>

        <Autocomplete
          style={{
            width: '200px',
            marginLeft: '10px'
          }}
          label={'Select Survey'}
          onChange={(_e, val) => {
            return setState({ ...state, rapidSurveyId: val?.id })
          }}
          options={state.surveys}
          getOptionLabel={option => option.title}
          renderInput={params => (
            <TextField
              {...params}
              style={{ height: '48px', marginTop: 0, marginBottom: 0 }}
              label="Select Survey"
              margin="normal"
            />
          )}
        />

        {/*
        // REVIEW: REMOVED FOR DEMO - ADD BACK
         <span
          style={{ margin: '15px 0 0 10px' }}
          className={
            !!state.rapidSurveyId
              ? `al-text-button`
              : 'al-text-button-disabled'
          }
          onClick={() =>
            !!state.rapidSurveyId
              ? dispatch({
                  type: actions.NEXT_STAGE
                })
              : null
          }>
          Next
        </span>
        // REMOVE BELOW
        */}


        <Button
          className="mp-send-email-action-button-next mp-send-email-action-button"
          style={{
            backgroundColor: `${!state.rapidSurveyId ? '#429bdc ' : '#195f93'
              }`
          }}
          disabled={!state.rapidSurveyId}
          onClick={async () => {
            setState({
              ...state,
              sendingEmails: true
            })
            await state.finishAction(
              dispatch,
              {
                items: listViewState.items,
                template: state.template,
                listId: listViewState.items[0].listId
              },
              state
            )
            setState({
              ...state,
              sendingEmails: false
            })
          }}>
          {state.sendingEmails ? (
            <CircularProgress
              style={{
                color: '#fff',
                width: '25px',
                height: '25px'
              }}
            />
          ) : (
            'Send'
          )}
        </Button>
        <span
          style={{ margin: '15px 0 0 10px' }}
          className={`al-text-button`}
          onClick={() => {
            dispatch({
              type: actions.END_ACTION
            })
          }}>
          Cancel
        </span>
      </div>
    </>
  )
}




function StatusPage() {
  useEffect(() => { }, [])
  const MPState = React.useContext(ListViewStateContext)
  const dispatch = React.useContext(ListViewDispatchContext)
  return (
    <div style={{ marginLeft: '10px' }}>
      Survey in progress
      <Button
        onClick={() => {
          dispatch({ type: actions.END_ACTION })
          massProcessingApi.stopMassAction(MPState.massAction.id)
        }}>
        Stop
      </Button>
    </div>
  )
}

async function sendSurveys(dispatch, { listId, items, template }, state) {

  await massProcessingApi.createMassAction({
    listId,
    type: 'rapidSurvey',
    data: {
      rapidSurveyId: state.rapidSurveyId
    },
    actions: items.map(item => ({
      // REVIEW: this seems a bit flaky, it could be a pdl id...
      //  but we might want to invite the users to join the platform...
      //    TODO: validate the platformUserId,
      item,
      platformUserId: item.data.id,
      subject: state.subject,
      surveyUUID: item.surveyUUID,
      listItemId: item.id,
      body: refillTemplate(template, item, state)
        .replaceAll('style="color: blue"', '')
        .replaceAll('style="color: blue;"', '')
        .replaceAll('style="color:blue"', '')
        .replaceAll('style="color:blue;"', ''),
      to:
        !!item.data.emails && !!item.data?.emails.length
          ? [
            item.data.email,
            ...item.data.emails

              .slice(1, state.maxNum_secondary_emails + 1)
              .map(e => e.email || e)
          ]
          : [item.data.email],
      cc: state.cc.map(e => e.email),
      bcc: state.bcc.map(e => e.email)
    }))
  }).then(mp => {
    dispatch({ type: actions.CREATE_MASS_ACTION_DONE, payload: mp.id })
  })

  dispatch({
    type: actions.FEEDBACK,
    payload: 'Survey In Progress'
  })
  dispatch({
    type: actions.NEXT_STAGE
  })
}
